import { render, staticRenderFns } from "./FreeJoin.vue?vue&type=template&id=5203dc98&scoped=true"
import script from "./FreeJoin.vue?vue&type=script&lang=js"
export * from "./FreeJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203dc98",
  null
  
)

export default component.exports